<!-- 予約/チケット内容確認(予約済み)-->
<template>
  <TemplateMfittMyTicket v-if="isReadyToDraw" />

  <!-- 描画ローディング -->
  <DialogInitialLoading v-else :timeoutSeconds="21000" />

  <!-- 電波状況が悪い場合のダイアログ　-->
  <DialogBadReception ref="DialogBadReception" :closeButtonClicked="backToMfittIndexPage" />

  <DialogDuringMaintenance ref="DialogDuringMaintenance" :closeButtonClicked="backToMfittIndexPage" />

  <DialogUnexpectedError ref="DialogUnexpectedError" :closeButtonClicked="backToMfittIndexPage" />
</template>

<script>
import TemplateMfittMyTicket from "@/views/Templates/MFITT/TemplateMfittMyTicket";

import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "MfittMyTicket",
  components: {
    TemplateMfittMyTicket,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const DialogBadReception = ref(false);
    const DialogUnexpectedError = ref(null);
    const DialogDuringMaintenance = ref(null);

    const isReadyToDraw = ref(false);
    const myLimitedExpressTicket = computed(
      () => store.getters["MFITT/myLimitedExpressTicket"]
    );

    const backToMfittIndexPage = () => {
      nativeHandlerService.returnNativeAppMfittIndexPage();
    };

    const getMyLimitedExpressTicket = async () => {
      // 引換券使用の場合は、is_used_couponをクエリに持つので、特急券IDを指定して情報取得
      if (route.query.is_used_coupon) {
        await Promise.all([
          // isPast:false
          API.getMyLimitedExpressTicket(route.params.id),
          // Myクーポン取得
          API.getCouponWithTicketId(route.params.id),
        ]);
      } else {
        // 引換券チケットを開いたあとに通常購入のチケットを開くとクーポンの情報が残り続けるためここでリセットする。
        store.commit("MFITT/setSelectedCoupon", null);
        await API.getMyLimitedExpressTicket(route.params.id);
      }
    };

    onMounted(async () => {
      try {
        await getMyLimitedExpressTicket();
        isReadyToDraw.value = true;
      } catch (e) {
        if (e.response.data.message) {
          if (e.response.data.message === "回線が込み合っています") {
            DialogBadReception.value.openDialog();
            // MWのメンテナンス中
          } else if (e.response.status == 503) {
            DialogDuringMaintenance.value.openDialog(e.response.data);
          } else {
            // nativeにエラー内容送信
            nativeHandlerService.ncSendMfittError(e.response.data.message);
            DialogUnexpectedError.value.openDialog();
          }
        } else {
          nativeHandlerService.ncSendMfittError("MFITTMyTicket onMounted()");
        }
      }
    });

    return {
      isReadyToDraw,
      myLimitedExpressTicket,
      DialogBadReception,
      DialogUnexpectedError,
      DialogDuringMaintenance,
      backToMfittIndexPage,
    };
  },
};
</script>
